/**
 * Localization Flags - Flag and Currency dropdown functionality
 * With smart positioning (opens up or down based on viewport space)
 */
(() => {
  if (window.localizationFlagsInitialized) {
    return;
  }

  window.localizationFlagsInitialized = true;

  class LocalizationFlags {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.thb-localization-flags').forEach(container => {
        this.setupDropdowns(container);
      });

      // Global click handler for closing dropdowns
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.thb-localization-flags')) {
          this.closeAllDropdowns();
        }
      });

      // Close on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllDropdowns();
        }
      });

      // Reposition on scroll/resize
      window.addEventListener('scroll', () => this.repositionOpenDropdowns(), { passive: true });
      window.addEventListener('resize', () => this.repositionOpenDropdowns(), { passive: true });
    }

    setupDropdowns(container) {
      const form = container.querySelector('form');

      // Setup language dropdown
      const langBtn = container.querySelector('.localization-flags__language .localization-flags__current');
      const langDropdown = container.querySelector('.localization-flags__language .localization-flags__dropdown');
      const langSelect = container.querySelector('.thb-language-code');

      if (langBtn && langDropdown && langSelect) {
        this.setupDropdown(langBtn, langDropdown, langSelect, form);
      }

      // Setup currency dropdown
      const currencyBtn = container.querySelector('.localization-flags__currency .localization-flags__current');
      const currencyDropdown = container.querySelector('.localization-flags__currency .localization-flags__dropdown');
      const currencySelect = container.querySelector('.thb-currency-code');

      if (currencyBtn && currencyDropdown && currencySelect) {
        this.setupDropdown(currencyBtn, currencyDropdown, currencySelect, form);
      }
    }

    setupDropdown(btn, dropdown, hiddenSelect, form) {
      // Toggle dropdown
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        this.closeAllDropdowns();
        if (!isOpen) {
          this.openDropdown(btn, dropdown);
        }
      });

      // Handle option selection
      dropdown.querySelectorAll('.localization-flags__option').forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          const value = option.dataset.value;
          hiddenSelect.value = value;

          // Trigger change event to ensure form state is synchronized
          const changeEvent = new Event('change', { bubbles: true });
          hiddenSelect.dispatchEvent(changeEvent);

          this.closeAllDropdowns();

          // Submit form after a brief delay to ensure value is set
          setTimeout(() => {
            if (form) form.submit();
          }, 50);
        });
      });
    }

    openDropdown(btn, dropdown) {
      // First show dropdown to measure it
      dropdown.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');

      // Determine position (up or down)
      this.positionDropdown(btn, dropdown);
    }

    positionDropdown(btn, dropdown) {
      const btnRect = btn.getBoundingClientRect();
      const dropdownHeight = dropdown.offsetHeight;
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - btnRect.bottom;
      const spaceAbove = btnRect.top;

      // Remove existing position class
      dropdown.classList.remove('is-open-up');

      // If not enough space below and more space above, open upward
      if (spaceBelow < dropdownHeight + 20 && spaceAbove > spaceBelow) {
        dropdown.classList.add('is-open-up');
      }
    }

    repositionOpenDropdowns() {
      document.querySelectorAll('.localization-flags__dropdown.is-open').forEach(dropdown => {
        const btn = dropdown.closest('.localization-flags__selector')?.querySelector('.localization-flags__current');
        if (btn) {
          this.positionDropdown(btn, dropdown);
        }
      });
    }

    closeAllDropdowns() {
      document.querySelectorAll('.localization-flags__current').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.localization-flags__dropdown').forEach(dropdown => {
        dropdown.classList.remove('is-open', 'is-open-up');
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new LocalizationFlags());
  } else {
    new LocalizationFlags();
  }
})();
